import { Component } from '@angular/core';
import { CouponFormsService } from '../../services/coupon-forms.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-physician-details',
  templateUrl: './physician-details.component.html',
  styleUrls: ['./physician-details.component.scss'],
})
export class PhysicianDetailsComponent {
  constructor(
    public formsService: CouponFormsService,
    private router: Router,
  ) {}

  get doctor() {
    return this.formsService.formPhysician.value;
  }

  getDoctorCompleteAddress(): string {
    return [
      this.doctor.addressStreet,
      this.doctor.addressNumber,
      this.doctor.addressNeighborhood,
      this.doctor.addressCity,
      this.doctor.addressState,
    ]
      .filter(Boolean)
      .join(', ');
  }

  get score() {
    return Number(this.doctor.score).toFixed(2);
  }

  get distance() {
    return Number(this.doctor.distanceInKilometers).toFixed(2);
  }

  get isAccredited() {
    return this.doctor.accredited;
  }

  goBack() {
    this.router.navigate(['/coupon/physician-list']);
  }

  goNext() {
    this.router.navigate(['/coupon/procedures'], {
      queryParams: {
        physicianId: this.doctor.physicianId,
        branchCode: this.doctor.physicianBranchCode,
      },
    });
  }
}
